import {
  Alert,
  AlertTitle,
  Box,
  Grid,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import { CustomButton } from '../../../../../../components';
import { formatCurrency } from '../../../../../../utils';
import { redeemBalance } from '../../../../../../core/balance/action';
import { useIsMobile } from '../../../../../../hooks';

function BalanceData({ createAccount }) {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const { user } = useSelector((store) => store.users);
  const { availableBalance, pendingBalance, isValid, loginLink } = useSelector(
    (store) => store.balance,
  );
  const [balance, setBalance] = useState(0);

  const handleChange = (e) => {
    const { value } = e.target;
    // Constraint value between 0 and available balance
    let newBalance = Math.min(availableBalance, parseFloat(value));
    newBalance = Math.max(0, newBalance);
    setBalance(newBalance);
  };

  const onRedeem = () => {
    if (balance) dispatch(redeemBalance(user.id, balance));
  };

  return user?.stripe_details?.id && user?.stripe_details?.details_submitted ? (
    <Grid container p={3}>
      <Grid item xs={12} sm={6} pb={1}>
        <Typography fontSize=".8em">Available</Typography>
        <Typography fontSize="1.1em">{formatCurrency(availableBalance)}</Typography>
      </Grid>
      <Grid item xs={12} sm={6} pb={1}>
        <Typography fontSize=".8em">Pending</Typography>
        <Typography fontSize="1.1em">{formatCurrency(pendingBalance)}</Typography>
      </Grid>
      {isValid ? (
        <>
          <Grid item xs={12} sm={7} display="flex" justifyContent="space-between" pt={2}>
            <TextField
              type="number"
              variant="standard"
              fullWidth
              value={balance}
              onChange={handleChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyOutlinedIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            pt={2}
            display="flex"
            justifyContent="end"
            ml={isMobile ? 0 : 4}>
            <CustomButton variant="contained" onClick={onRedeem} disabled={balance < 0.1}>
              Redeem
            </CustomButton>
          </Grid>
        </>
      ) : (
        <Grid item xs={12} display="flex" justifyContent="center" pt={3}>
          <Alert severity="warning">
            Finish setting up your account in
            <Link href={loginLink} target="_blank" underline="none" sx={{ color: '#663c00' }}>
              <strong> Stripe Dashboard </strong>
            </Link>
            to transfer funds.
          </Alert>
        </Grid>
      )}

      <Grid item xs={12} display="flex" justifyContent="center" pt={3}>
        <Link href={loginLink} target="_blank" underline="none">
          <CustomButton variant="outlined">Stripe Dashboard</CustomButton>
        </Link>
      </Grid>
    </Grid>
  ) : (
    <Box display="flex" justifyContent="center" p={3}>
      <CustomButton
        sx={{ width: isMobile ? '100%' : '50%' }}
        variant="contained"
        onClick={createAccount}>
        Connect with Stripe
      </CustomButton>
    </Box>
  );
}

BalanceData.propTypes = {
  createAccount: PropTypes.func.isRequired,
};

export default BalanceData;
